import { render, staticRenderFns } from "./MemberFilterJudgeLayout.vue?vue&type=template&id=39c33638&scoped=true&"
import script from "./MemberFilterJudgeLayout.vue?vue&type=script&lang=js&"
export * from "./MemberFilterJudgeLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c33638",
  null
  
)

export default component.exports